// Sign in with Apple no site (popup). Devolve o identity token que o backend
// valida em POST /recruiters/recruiter/login-apple — o mesmo endpoint da app
// iOS. O Services ID tem de estar agrupado com a app no portal da Apple
// (Primary App ID mz.co.gugla.empresas) para a mesma pessoa ter a mesma conta.
export const APPLE_WEB_CLIENT_ID = 'mz.co.gugla.empresas.web'
export const APPLE_REDIRECT_URI = 'https://empresas.gugla.co.mz/app/pagar'

const SCRIPT_SRC =
  'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/pt_PT/appleid.auth.js'

let loading = null

function loadAppleScript() {
  if (window.AppleID) return Promise.resolve()
  if (loading) return loading
  loading = new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.src = SCRIPT_SRC
    script.async = true
    script.onload = () => resolve()
    script.onerror = () => {
      loading = null
      reject(new Error('apple_script'))
    }
    document.head.appendChild(script)
  })
  return loading
}

/** true quando a pessoa fechou a janela da Apple (não é erro a mostrar). */
export function isAppleCancel(err) {
  const code = err && err.error
  return code === 'popup_closed_by_user' || code === 'user_cancelled_authorize'
}

/**
 * Abre o "Continuar com a Apple". Resolve com { idToken, email, name } —
 * email/nome só vêm na primeira autorização desta conta Apple.
 */
export function signInWithApple() {
  return loadAppleScript().then(() => {
    window.AppleID.auth.init({
      clientId: APPLE_WEB_CLIENT_ID,
      scope: 'name email',
      redirectURI: APPLE_REDIRECT_URI,
      usePopup: true,
    })
    return window.AppleID.auth.signIn()
  }).then((res) => {
    const user = res.user || {}
    const n = user.name || {}
    const name = [n.firstName, n.lastName].filter(Boolean).join(' ')
    return {
      idToken: res.authorization.id_token,
      email: user.email || null,
      name: name || null,
    }
  })
}
